import axios from 'axios';

/**
 * Isolated HTTP client for public vendor onboarding.
 * Does not use the global axios interceptors (no JWT / session headers).
 */
const vendorOnboardingHttp = axios.create({
  withCredentials: false,
  headers: {
    Accept: 'application/json',
  },
});

export default vendorOnboardingHttp;
